export const CHECK_OPTIC_PATH = "CHECK_OPTIC_PATH"
export const OPTIC_CANCEL_PATH = "OPTIC_CANCEL_PATH"
export const SET_OPTIC_MEDICAL_PATH = "SET_OPTIC_MEDICAL_PATH"
export const OPTIC_MESSAGE = "OPTIC_MESSAGE"
